import axios from "./axiosInstance";

const blogsAPI = {
  getDetails: (params) => axios.get("blogs/", {params}),

  addDetails: (payload) => axios.post("blogs/", payload),

  updateDetails: (id, payload) => axios.put(`blogs/${id}`, payload),

  getSingleDetails: (id) => axios.get(`blogs/${id}`),

  updateStatus: (id) => axios.patch(`blogs/${id}/status`),

  updateOrder: (payload) => axios.put("blogs/reorder", payload),

  deleteItem: (id) => axios.delete(`blogs/${id}`),
};

export default blogsAPI;
